<div class="app-list-container">
  <div class="app-list-inner-cont">
    <div class="grid-header" [hidden]="reportViewType !== 'list'">
      <div class="grid-header-item  {{header.key}} {{header.sort}}" *ngFor="let header of currentConfig?.gridHeaders"
        [hidden]="header.hidden" (click)="toggleSort(header)">
        <div>
          <ng-container *ngIf="!(searchEnabled && currentConfig?.key === 'apps' && header?.key === 'appTitle')">
            <div class="label" data-toggle="tooltip" [attr.title]="header?.tooltip" [attr.title]="header?.tooltip">
              {{header?.label}}
            </div>
          </ng-container>
          <ng-container *ngIf="searchEnabled && currentConfig?.key === 'apps' && header?.key === 'appTitle'">
            <div class="input-group search-app">
              <span class="input-group-addon" id="basic-addon1">
                <i class="fa fa-search"></i>
              </span>
              <input type="text" class="form-control" (keydown.escape)="clearAppGlobalSearchClick()"
                (keydown.enter)="appGlobalSearchClick()" [(ngModel)]="appGlobalSearchParamModel"
                placeholder="Search App Name, Bundle Id or Track Id" aria-describedby="basic-addon1">
              <ng-container *ngIf="appGlobalSearchParamModel && appGlobalSearchParamModel?.length > 0">
                <a class="btn btn-link clear-app-search p-0" (click)="clearAppGlobalSearchClick()"><i
                    class="fa fa-times"></i></a>
              </ng-container>
            </div>
          </ng-container>

          <div class="sort-cont" *ngIf="!(currentConfig?.key === 'apps' && header?.key === 'appTitle')">
            <i class="fa fa-caret-up"></i>
            <i class="fa fa-caret-down"></i>
          </div>
        </div>
      </div>
      <div class="grid-header-item" *ngIf="showFollowing"></div>
    </div>
    <div class="grid-data" [ngClass]="{'show-details': showDetails}" [hidden]="reportViewType !== 'list'">
      <div class="grid-data-item" *ngFor="let dataItem of gridData; let id = index">
        <div class="grid-data-item-col {{header.key}}" *ngFor="let header of currentConfig?.gridHeaders"
          [hidden]="header.hidden">
          <div [innerHTML]="dataItem[header.key+'HTML']"></div>
        </div>
        <div class="grid-data-item-col" *ngIf="showFollowing">
          <div class="btn-group">
            <button class="btn btn-secondary disabled" title="No updates available." (click)="viewUpdates(dataItem)">
              <img src="/assets/icons/icon-clock-arrow-disabled.svg" alt="No updates available." />
            </button>
            <button type="button" class="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
              aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu py-0">
              <ng-container
                *ngIf="notificationSettings | containsValue:(dataItem.appId||dataItem.domain):'id' then DisableNotification else EnableNotification"></ng-container>
              <ng-template #EnableNotification>
                <button class="btn btn-secondary dropdown-item py-3" (click)="enableNotification(dataItem)">
                  <i class="fa fa-toggle-on mr-2"></i>
                  <span>Enable Notification</span>
                </button>
              </ng-template>
              <ng-template #DisableNotification>
                <button class="btn btn-secondary dropdown-item py-3" (click)="disableNotification(dataItem)">
                  <i class="fa fa-toggle-off mr-2"></i>
                  <span>Disable Notification</span>
                </button>
              </ng-template>
              <button class="btn btn-secondary dropdown-item py-3" (click)="editNotification(dataItem)">
                <i class="fa fa-pencil mr-2"></i>
                <span>Edit Notification</span>
              </button>
              <div class="dropdown-divider my-0"></div>
              <button class="btn btn-secondary dropdown-item py-3" (click)="unfollow(dataItem)">
                <i class="fa fa-trash-o mr-2"></i>
                <span>Unfollow</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-data-item load-more" *ngIf="showLoadMore || showLoadingMore">
        <button [hidden]="showLoadingMore" class="btn btn-primary" (click)="loadMore()"> load more results</button>
        <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
      </div>
    </div>
  </div>
  <div class="grid-data-item load-more mobile-load-more" *ngIf="showLoadMore || showLoadingMore">
    <button [hidden]="showLoadingMore" class="btn btn-primary" (click)="loadMore()">Show More</button>
    <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
  </div>
</div>
